import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CompanySubscriptionPlan } from '../../models/SubscriptionPlan';
import { RootState } from '../rootStore';
import { PreviousPage, RoutePageName } from '../../pages/PI/PIOfferingBoard/Model/OfferingBoardAdd';

export interface PIOfferingBoardReducer {
  previousPage: {
    [pageName: string]: PreviousPage;
  };
}

const initialValue: PIOfferingBoardReducer = {
  previousPage: {},
};

const PIOfferingBoardSlice = createSlice({
  name: 'offeringBoard',
  initialState: initialValue,
  reducers: {
    setPreviousPage: (
      state: PIOfferingBoardReducer,
      action: PayloadAction<{ pageName: RoutePageName; value: PreviousPage }>,
    ) => {
      state.previousPage[action.payload.pageName] = action.payload.value;
      return state;
    },
  },
});

export const { setPreviousPage } = PIOfferingBoardSlice.actions;

export const selectPreviousPage = (pageName: RoutePageName) => (rootState: RootState) =>
  rootState.pIOfferingBoard?.previousPage[pageName];

export default PIOfferingBoardSlice.reducer;
